<template>
  <v-layout column align-center justify-start class="relative">
    <div style="
        width: 100%;
        height: 130px;
        background: rgb(236, 236, 236);
        position: absolute;
        top: 19px;
      ">
      <v-icon style="
          font-size: 158px;
          color: rgb(250, 251, 251);
          position: absolute;
          right: 9px;
          bottom: -47px;
        ">voicemail</v-icon>
    </div>

    <div class="pa-4">
      <!-- generation wizard-->

      <v-stepper v-model="e1" class="transparent elevation-0 audioWizard">
        <v-stepper-header class="elevation-0">
          <v-stepper-step :complete="e1 > 1" step="1" color="rgb(128, 195, 16)">Script</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e1 > 2" step="2" color="rgb(128, 195, 16)">Voice</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e1 > 3" step="3" color="rgb(128, 195, 16)">Done!</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items class="relative" style="padding: 10px; padding-top: 0px">
          <v-progress-linear color="primary" indeterminate style="height: 2px; margin: 0px"
            v-show="audioGenerationStartProgress"></v-progress-linear>
          {{/*  CHOOSE LANGUAGE AND ADD TEXT  STEP - 1  */}}
          <v-stepper-content step="1" class="white">
            <v-card color="transparent elevation-0" height="470px" width="800px">
              <v-form ref="form1" lazy-validation>
                <div class="heading field-title">Select language</div>

                <v-select required class :items="$store.state.languages" :value="$store.state.selectedLanguage"
                  item-text="language" item-value="code" @input="setSelectedLanguage" return-object
                  :rules="requiredField"></v-select>

                <v-tabs slider-color="primary" v-on:change="onTabChanged" v-model="activeTab">
                  <v-tab>Text Input</v-tab>
                  <v-tab>SSML Input</v-tab>
                </v-tabs>

                <div class="mt-3 mb-2"></div>

                <v-textarea ref="inputScript" outline v-model="userScript" hint :maxlength="maxCharsDynamic"
                  :rules="requiredField" v-on:keyup="countdown" height="250" hide-details></v-textarea>
                <p style="text-align: right; float: right">
                  {{ remainingCount }}
                </p>
                <v-layout align-start row v-if="areEmotionsSupported()">
                  <v-flex xs3>
                    <v-select :items="emotions.list" label="Chose emotion" clearable v-model="emotions.choice">
                    </v-select>
                  </v-flex>
                  <v-flex class="pt-3 pl-2" xs3>
                    <v-btn color="primary" small :loading="emotions.button.loading" :disabled="disableEmotionSSMLButton"
                      @click="generateEmotionSSML()">to SSML</v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>

            <v-toolbar dense transparent class="elevation-0" color="white">
              <v-spacer></v-spacer>
              <v-btn color="primary" class="white--text elevation-0 no-margin"
                @click="validate('form1', 2) && clearPreSelectedVoice()">Next</v-btn>
            </v-toolbar>
          </v-stepper-content>

          {{/*  CHOOSE VOICE STEP - 2  */}}
          <v-stepper-content step="2" class="white">
            <v-card class="elevation-0" color="white" height="470px" width="800px">
              <v-form ref="form2" lazy-validation>
                <div class="heading field-title">Select voice</div>

                <v-layout row wrap class justify-center>
                  <!-- !!!! reset radio selection on Back -->
                  <!-- female voices-->
                  <div style="width: 280px" v-if="getFemaleCharacters().length">
                    <v-layout column wrap class="mt-1" justify-center>
                      <div style="text-align: center">
                        <img class style="position: relative; z-index: 22" src="../../assets/avatarVoiceFGrey.png" />
                      </div>
                      <div style="
                          min-height: 350px;
                          margin: 2px 10px;
                          position: relative;
                          top: -19px;
                          z-index: 1;
                          border-top: 5px solid rgba(232, 231, 231, 0.74);
                        ">
                        <v-radio-group v-model="selectedCharacter" style="
                            margin-top: 40px;
                            position: relative;
                            left: 30px;
                          ">
                          <template v-for="fChars in getFemaleCharacters()">
                            <v-layout row wrap justify-start :key="fChars.code">
                              <div style="width: 125px; display: flex">
                                <v-radio :label="fChars.name" :value="fChars" :key="fChars.code" color="black">
                                </v-radio>
                                <span v-if="
                                    fChars.voiceType == 'Neural' ||
                                    fChars.voiceType == 'Wavenet'
                                  ">
                                  <i style="
                                      margin-top: 12px;
                                      padding: 0px;
                                      font-size: 20px;
                                    " class="material-icons md-dark">stars</i>
                                </span>
                              </div>

                              <!--
								<v-tooltip bottom>
									<v-btn slot="activator" icon color="primary--text" class="" style="position:relative;left:12px;"><v-icon class="icon-button-shadow">star_border</v-icon></v-btn>
								<span>Add {{fChars.name}} to Favorite Voices</span>
								</v-tooltip>
                              -->
                              <v-tooltip bottom>
                                <lingo_audio slot="activator" :play_button_class="`icon-button-shadow`"
                                  :play_button_color="`primary--text`" :label_class="``" :label_text="``"
                                  :file="fChars.voiceSample"></lingo_audio>
                                <span>Hear {{ fChars.name }} Speak</span>
                              </v-tooltip>
                            </v-layout>
                          </template>
                        </v-radio-group>
                      </div>
                    </v-layout>
                  </div>

                  <!-- male voices-->
                  <div style="width: 280px" v-if="getMaleCharacters().length">
                    <v-layout column wrap class="mt-1" justify-center>
                      <div style="text-align: center">
                        <img class style="position: relative; z-index: 22" src="../../assets/avatarVoiceMGrey.png" />
                      </div>
                      <div style="
                          min-height: 350px;
                          margin: 2px 10px;
                          position: relative;
                          top: -19px;
                          z-index: 1;
                          border-top: 5px solid rgba(232, 231, 231, 0.74);
                        ">
                        <v-radio-group v-model="selectedCharacter" style="
                            margin-top: 40px;
                            position: relative;
                            left: 30px;
                          ">
                          <template v-for="mChars in getMaleCharacters()">
                            <v-layout row wrap justify-start :key="mChars.code">
                              <div style="width: 125px; display: flex">
                                <v-radio :label="mChars.name" :value="mChars" :key="mChars.code" color="black">
                                </v-radio>
                                <span v-if="
                                    mChars.voiceType == 'Neural' ||
                                    mChars.voiceType == 'Wavenet'
                                  ">
                                  <i style="
                                      margin-top: 12px;
                                      padding: 0px;
                                      font-size: 20px;
                                    " class="material-icons md-dark">stars</i>
                                </span>
                              </div>
                              <!--
								<v-tooltip bottom>
									<v-btn slot="activator" icon color="primary--text" style="position:relative;left:12px;"><v-icon class="icon-button-shadow">star_border</v-icon></v-btn>
								<span>Add {{mChars.name}} to Favorite Voices</span>
								</v-tooltip>
                              -->

                              <v-tooltip bottom>
                                <lingo_audio slot="activator" :play_button_class="`icon-button-shadow`"
                                  :play_button_color="`primary--text`" :label_class="``" :label_text="``"
                                  :file="mChars.voiceSample"></lingo_audio>
                                <span>Hear {{ mChars.name }} Speak</span>
                              </v-tooltip>
                            </v-layout>
                          </template>
                        </v-radio-group>
                      </div>
                    </v-layout>
                  </div>
                </v-layout>
              </v-form>
            </v-card>

            <v-toolbar dense transparent class="elevation-0" color="white">
              <v-btn flat class="grey--text text--darken-1" @click="
                  e1 = 1;
                  selectedCharacter = null;
                ">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="white--text elevation-0 no-margin" @click="validate('form2', 3)">Next
              </v-btn>
            </v-toolbar>
          </v-stepper-content>

          {{/*  CHOOSE FILE FORMAT AND FILE NAME STEP - 3  */}}
          <v-stepper-content step="3" class="white">
            <v-card class="elevation-0" color="white" height="470px" width="800px">
              <v-form ref="form3" lazy-validation>
                <span>
                  <div class="heading field-title">Select audio format</div>
                  <v-select label data-vv-name="select" required class :items="$store.state.formats"
                    :value="$store.state.selectedFormat" @input="setSelectedFormat" :rules="requiredField"></v-select>
                </span>
                <div class="heading field-title mt-3">Enter file name</div>
                <v-text-field label v-model="fileName" counter :maxlength="30" :rules="requiredField" class="ml-1">
                </v-text-field>
              </v-form>
            </v-card>

            <v-toolbar dense transparent class="elevation-0" color="white">
              <v-btn flat class="grey--text text--darken-1" @click="e1 = 2" v-if="generationInProgress">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="white--text elevation-0 no-margin"
                @click="validate('form3') && createAudio()" v-if="generationInProgress">Create Audio</v-btn>
              <v-btn color="primary" class="white--text elevation-0 no-margin" @click="resetAudioGenerator()"
                v-if="!generationInProgress">Create Another Audio</v-btn>
            </v-toolbar>

            <!--
        <v-btn color="info" flat class="white--text elevation-0 no-margin">
          Save Configuration
        </v-btn>
            -->
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>

    <v-snackbar v-model="snackbar" :timeout="timeout" color="white" top right auto-height>
      <div style="color: rgb(0, 159, 220)">
        Audio generation has started. Your file will appear in
        <router-link to="/app/my_files" class="myFilesLink grey--text text--darken-2">My Files</router-link>shortly and
        you will also receive an e-mail notification with download
        link
      </div>
    </v-snackbar>
  </v-layout>
</template>

<style>
  .audioWizard .v-toolbar__content {
    padding: 0px;
  }

  .v-radio .v-label {
    color: black;
  }

  .v-radio {
    margin-bottom: 0px !important;
  }

  .field-title {
    color: #757575 !important;
  }

  .no-margin {
    margin: 0px;
  }

  .v-stepper__step__step {
    width: 50px;
    height: 50px;
    min-width: 50px;
    min-height: 50px;
    font-size: 2rem;
    font-weight: 300;
  }

  .v-stepper__header {
    height: 105px;
  }

  .v-stepper__label {
    font-size: 1.6rem;
    font-weight: 300;
  }

  .myFilesLink {
    padding: 0px 5px;
  }

  .elevation-0 {
    box-shadow: none !important;
  }

  .shadow {
    --box-shadow: 0px 1px 6px 0px #cec6c6;
  }

  .round--border-8 {
    border-radius: 8px !important;
  }

  .v-tabs__item--active {
    background-color: secondary;
  }
</style>


<style>
  .v-text-field__slot {
    height: 100%;
  }
</style>


<script>
  import { Auth } from "./auth/cognito_auth";
  import AudioGeneratorService from "../service/audioGeneratorService";
  import lingo_audio from "./AudioPlayer";

  export default {
    name: "lingo_audio_generator",
    data() {
      return {
        e1: 0,
        requiredField: [(v) => !!v || "Field is required"],
        maxWords: 100,
        maxCharsAbsolute: 20000, //enough for the biggest price plan ?
        maxCharsDynamic: this.maxCharsAbsolute,
        snackbar: false,
        timeout: 8000,
        generationInProgress: true,
        remainingCount: "?",
        selectedCharacter: "",
        audioGenerationStartProgress: false,
        selectedLanguageCode: "",
        activeTab: 0,
        useEmotionalVoicesOnly: false,
        emotions: {
          choice: "",
          list: ["Angry", "Calm", "Surprised", "Happy", "Sad"],
          button: {
            loading: false,
            disabled: true,
          },
        },
      };
    },
    methods: {
      areEmotionsSupported() {
        return (
          this.activeTab === 0 &&
          (this.selectedLanguageCode.startsWith("en-") ||
            this.selectedLanguageCode.startsWith("es-"))
        );
      },
      generateEmotionSSML() {
        this.emotions.button.loading = true;
        this.useEmotionalVoicesOnly = true;
        this.postData(
          "https://r1g7u9e875.execute-api.eu-west-1.amazonaws.com/prod/emotion",
          {
            text: this.userScript,
            language: "en", //it is not take in consideration by the Lambda
            emotion: this.emotions.choice.toUpperCase(),
          }
        )
          .then((data) => {
            this.userScript = data.ssml;
            this.activeTab = 1; //select the SSML tab
            this.onTabChanged(1); //as the event is not populated we need to call the method on our own.
          })
          .finally(() => {
            this.emotions.button.loading = false;
          });
      },

      onTabChanged(num) {
        this.$store.commit("setUserScriptType", num == 0 ? "text" : "ssml");
      },

      validate(formN, nextStep) {
        if (this.$refs[formN].validate()) {
          if (nextStep) {
            this.e1 = nextStep;
          }
          return true;
        }
        return false;
      },
      getFemaleCharacters() {
        // ! assumes all languages have female voices
        var characters = this.getCharacters(0);
        if (characters.length && !this.selectedCharacter) {
          if (this.$store.state.selectedCharacter) {
            // preselected voice from another view, e.g. Gallery
            this.selectedCharacter = this.$store.state.selectedCharacter; // clear after use, e.g. on wizard completion
          } else {
            this.selectedCharacter = characters[0];
          }
        }
        return characters;
      },
      getMaleCharacters() {
        return this.getCharacters(1);
      },
      getCharacters(genderIndex) {
        if (
          !this.$store.state.voices ||
          !this.$store.state.voices[genderIndex] ||
          !this.$store.state.voices[genderIndex].characters
        ) {
          return [];
        }

        if (this.useEmotionalVoicesOnly) {
          return this.$store.state.voices[genderIndex].characters.filter(
            function (character) {
              return character.vendor == "aws";
            }
          );
        }
        return this.$store.state.voices[genderIndex].characters;
      },
      resetValidation() {
        this.$refs.form1.reset();
        this.$refs.form2.reset();
        this.$refs.form3.reset();
      },
      setSelectedLanguage(language) {
        this.$store.commit("setSelectedLanguage", language);
        this.selectedLanguageCode = language.code;
        this.selectedCharacter = null;
      },
      setSelectedCharacter(character) {
        this.$store.commit("setSelectedCharacter", character);
      },
      setSelectedFormat(format) {
        this.$store.commit("setSelectedFormat", format);
      },
      createAudio() {
        var that = this;
        this.generationInProgress = false;
        this.audioGenerationStartProgress = true;
        this.clearPreSelectedVoice();
        AudioGeneratorService.generateAudio(this.audioParams(), function () {
          that.snackbar = true;
          that.audioGenerationStartProgress = false;
          that.$root.$emit("refreshUserCharacters");
        });
      },
      resetAudioGenerator() {
        this.generationInProgress = true;
        this.e1 = 1;
        this.audioGenerationStartProgress = false;
        this.clearPreSelectedVoice();
        this.resetValidation();
      },
      clearPreSelectedVoice() {
        localStorage.setItem("selectedLanguageCode", null);
        localStorage.setItem("selectedCharacter", null);
      },
      audioParams() {
        return {
          language: this.$store.getters.language.code,
          ttsProvider: this.selectedCharacter.vendor,
          userScript: this.$store.getters.userScript,
          userScriptType: this.$store.getters.userScriptType,
          voice: this.selectedCharacter.code,
          format: this.$store.getters.format,
          fileName: this.$store.getters.fileName,
          voiceType: this.selectedCharacter.voiceType,
        };
      },
      countdown() {
        var text = this.$store.getters.userScript;
        var wordCount = 0;
        if (text) {
          wordCount = text.split(" ").length;
        }
        this.remainingCount = this.formatRemainingWordsHint(wordCount);
        if (this.maxWords - wordCount < 1) {
          // adjust max chars in text area to prevent user entering more text
          this.maxCharsDynamic = text.length;
        } else {
          this.maxCharsDynamic = this.maxCharsAbsolute;
        }
      },
      formatRemainingWordsHint(wordCount) {
        return this.maxWords - wordCount + " words left";
      },
      async postData(url = "", data = {}) {
        const response = await fetch(url, {
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          // credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data), // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
      },
    },
    created() {
      var that = this;
      if (!Auth.isUserLoggedIn()) {
        this.$router.push({
          path: "/",
        });
        Auth.login(); // how to redirect to this page after login?
      }
      this.$store.subscribe((mutation) => {
        if (mutation.type == "setUserCharactersLeft") {
          that.maxWords = mutation.payload;
          //that.remainingCount = that.formatRemainingWordsHint(0);
          that.countdown();
        }
      });

      var charsLeftInStore = this.$store.getters.userCharactersLeft;
      if (!isNaN(charsLeftInStore)) {
        // store already initialized; if not, wait for the mutation event above
        this.maxWords = charsLeftInStore;
        this.countdown();
      }
      this.activeTab = 0;
      this.onTabChanged(0); //set the first tab as active
    },
    mounted() {
      // pre-selected voice from Gallery
      if (
        localStorage.getItem("selectedLanguageCode") &&
        localStorage.getItem("selectedCharacter")
      ) {
        this.$store.commit(
          "setSelectedLanguageByCode",
          localStorage.getItem("selectedLanguageCode")
        );
        this.$store.commit(
          "setSelectedCharacter",
          localStorage.getItem("selectedCharacter")
        );
      }
    },
    computed: {
      userScript: {
        get() {
          return this.$store.getters.userScript;
        },
        set(value) {
          this.$store.commit("setUserScript", value);
        },
      },
      fileName: {
        get() {
          return this.$store.fileName;
        },
        set(value) {
          this.$store.commit("setFileName", value);
        },
      },
      disableEmotionSSMLButton: function () {
        return this.emotions.choice === undefined || this.emotions.choice === "";
      },
    },
    components: {
      lingo_audio,
    },
  };
</script>